import { type ReactNode } from 'react';
import type { Creator } from '@/types';

// Renders the appeal status block in the collector's detail view. Replaces
// the previous one-liner that said "pendiente de revisión" no matter what
// the actual status was — now each resolution has its own message, and
// rejections show the admin's note (when present) so the collector
// understands the verdict instead of just seeing the badge flip.

function PendingText(): ReactNode {
  return (
    <p className="mt-sm text-xs text-text-tertiary">
      Apelación enviada — pendiente de revisión por un admin.
    </p>
  );
}

function AcceptedText(): ReactNode {
  return (
    <p className="mt-sm text-xs text-success">
      Apelación aceptada — el lead vuelve a estar validado.
    </p>
  );
}

function RejectedText({ note }: { note: string }): ReactNode {
  return (
    <div className="mt-sm flex flex-col gap-1">
      <p className="text-xs text-error">
        Apelación rechazada — el admin mantiene la decisión de la IA.
      </p>
      {note && (
        <div className="rounded-md border border-white/[0.06] bg-surface-elevated p-sm">
          <p className="text-xs font-medium text-text-tertiary">
            Motivo del rechazo
          </p>
          <p className="text-xs text-text-primary">{note}</p>
        </div>
      )}
    </div>
  );
}

export function CreatorAppealStatusBlock({
  creator,
}: {
  creator: Creator;
}): ReactNode {
  const s = creator.appeal_status;
  if (s === 'pending_review') return <PendingText />;
  if (s === 'accepted') return <AcceptedText />;
  if (s === 'rejected')
    return <RejectedText note={creator.appeal_admin_note || ''} />;
  return null;
}
